import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VCard,
    { staticClass: "order-md-last order-first col-md-3 col-12 pl-md-0 mb-2" },
    [
      _c(VCardTitle, { staticClass: "pointer" }, [
        _vm._v(" " + _vm._s(_vm.$t("titles.search_filters")) + " "),
      ]),
      _c(
        VCardText,
        { staticClass: "pa-2" },
        [_c(VRow, { attrs: { dense: "" } }, [_vm._t("default")], 2)],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }